import { ReactNode } from 'react';

export const copyMode = {
  crossEnv: 'crossEnv',
  currentEnv: 'currentEnv',
} as const;

export type CopyMode = (typeof copyMode)[keyof typeof copyMode];

export interface CopyDialogProps {
  open: boolean;
  title: string;
  onClose: () => void;
  crossEnvForm: ReactNode;
  currentEnvForm: ReactNode;
  descriptions: string | Record<CopyMode, string>;
}
